import { useLocation, useNavigate } from 'react-router';
import { Empty, Animate } from '@/shared/components';
import { Tooltip, Button } from '@heroui/react';
import { RoutePaths } from '@/routing/RoutePaths';

export const BackNavigation = ({ title }) => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Empty when={location.pathname === RoutePaths().login.login()}>
      <Animate id="back" layout className="flex min-h-[40px] items-center gap-2">
        <Tooltip content="Go back" delay={3000}>
          <Button
            isIconOnly
            size="sm"
            variant="light"
            onPress={() => navigate(RoutePaths().login.login())}
          >
            <i className="text-lg ri-arrow-left-s-line" />
          </Button>
        </Tooltip>
        <h1 className="text-md font-medium">{title}</h1>
      </Animate>
    </Empty>
  );
};
